export const template =
    'Title:\n' +
    'Date:\n' +
    'Author: Quynh Nguyen\n' +
    'Author_slug: quynh-nguyen\n' +
    'Author_image: ../../theme/images/authors/quynh-nguyen.png\n' +
    'Author_description: A passionate content writer specializing in marketing and content marketing strategies. Expertise in crafting compelling narratives helps elevate brands and engage audiences effectively.\n' +
    'Category:\n' +
    'Breadcrumb:\n' +
    'Slug:\n' +
    'Tags:\n' +
    'breadcrumb_children:\n' +
    'breadcrumb_url:\n' +
    'description:\n' +
    'thumbnail:\n\n' +
    '[TOC]\n\n';
